import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
// *DICCIONARIOS
import { moduloSeguridad } from '../../diccionarios/seguridadModulo';
// *COMPONENTES
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { AgGridAngular } from 'ag-grid-angular';
// *SERVICIOS
import { RolService } from '../../services/rol.service';
import { RolSesionService } from '../../services/rol-sesion.service';
import { RolSeguridadModel } from '../../models/rolSeguridad.model';
import { SesionSeguridadModel } from '../../models/sesionSeguridad.model';
import { SesionService } from '../../services/sesion.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { CommonFormService } from 'src/app/shared/utils/common-form.service';


@Component({
  selector: 'app-rol-sesion',
  templateUrl: './rol-sesion.component.html',
  styleUrls: ['./rol-sesion.component.css']
})
export class RolSesionComponent implements OnInit {

  formulario: FormGroup;
  mostrarFormulario: boolean = false;
  editableForm: boolean = false;
  cmbDisabled: boolean;

  @ViewChild('agGrid') agGrid: AgGridAngular;
  columnDefs: any[];
  rowData: any[];
  frameworkComponents: any;
  rowSelection: any;
  gridApi: any;
  gridColumnApi: any;

  textoBuscar: string;
  textBoton: string;

  DAT_BTNS: any;
  DAT_BTNCSS: any;
  DAT_MSG: any;
  DAT_TITULOS: any;

  cmbListRol: RolSeguridadModel[];
  cmbListSesion: SesionSeguridadModel[];
  cmbListAplicacion: SesionSeguridadModel[];
  buscarListaSession: SesionSeguridadModel[];

  diccionarioModulo: any = {};
  titulo: any;

  constructor(
    private fb: FormBuilder,
    private _util: UtilsService,
    private _rolSesion: RolSesionService,
    private _commonForm: CommonFormService,
    private _rol: RolService,
    private _sesion: SesionService
  ) {
    this.diccionarioModulo = moduloSeguridad;
  }

  ngOnInit() {
    this.DAT_BTNS = moduloSeguridad.button.buttonsNombre;
    this.DAT_MSG = moduloSeguridad.mensajes;
    this.DAT_BTNCSS = moduloSeguridad.button.buttonsCss;
    this.DAT_TITULOS = moduloSeguridad.titulos.rolSesion;

    this.titulo = this.DAT_TITULOS.tituloCardListar;

    this.formulario = this.fb.group({
      sesionId: ['', [Validators.required]],
      rolId: ['', [Validators.required]],
      application: ['']
    });

    this.gridComponent();
    this.getAllRol();
    this.getAllSesion();
    this.getListaAplicacion();
    this.getAllRolSesion();
  }

  gridComponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      {
        headerName: 'DESCRIPCION',
        field: 'sesionDescripcion',
        sortable: true, filter: true,
        // checkboxSelection: true,
        // headerCheckboxSelection: true,
        width: 330
      },
      {
        headerName: 'COD. SESION',
        field: 'codSesion',
        sortable: true,
        filter: true,
        width: 330
      },
      {
        headerName: 'ROL',
        field: 'rolDescripcion',
        sortable: true,
        filter: true,
        width: 330
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        // width: 115,
        cellRendererParams: {
          onClick: this.eliminarLinea.bind(this),
          label: this.DAT_BTNS.eliminar,
          colorBoton: this.DAT_BTNCSS.danger
        }
      }
    ];
    this.rowSelection = 'multiple';
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  nuevo() {
    this._commonForm.abrirFormularioParaGuardar(this);
    this.cmbDisabled = false;
    this.titulo = this.DAT_TITULOS.tituloCardGuardar;
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  changeAplicacion(target) {
    const posicion = target.options.selectedIndex;
    const nombre = target[posicion].text;
    this.cmbListSesion = this.buscarListaSession.filter((item: any) => {
      if (item.application === nombre) {
        return item;
      }
    });
  }

  acciones(event) {
    if (event === 'guardar') {
      if (this.editableForm) {
      } else {
        this.guardarRolSesion();
      }
    } else {
      this.regresar();
    }
  }

  regresar() {
    this._commonForm.limpiarYregrear(this);
    this.titulo = this.DAT_TITULOS.tituloCardListar;
  }

  // *SERVICIOS
  getAllRol() {
    this._rol.getAll().subscribe((res: any) => {
      this.cmbListRol = res;
    }, (err) => {
      this.cmbListRol = [];
    });
  }

  getAllSesion() {
    this._sesion.getAll().subscribe((res: any) => {
      this.cmbListSesion = res;
      this.buscarListaSession = res;
    }, (err) => {
      this.cmbListSesion = [];
      this.buscarListaSession = [];
    });
  }

  getListaAplicacion() {
    this._sesion.getAplicacion().subscribe((resp) => {
      this.cmbListAplicacion = resp;
    }, (err) => {
      this.cmbListAplicacion = [];
    });
  }

  getAllRolSesion() {
    this._rolSesion.getAll().subscribe((res: any[]) => {
      this.rowData = res;
    }, (err) => {
      this.rowData = [];
    });
  }

  guardarRolSesion() {
    this._util.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.guardar,
        text: ``,
        action: this.DAT_BTNS.guardar,
        funcion: this._rolSesion.guardarRolSesion(this.formulario.value),
      }
    ).then((res: any) => {
      this.getAllRolSesion();
      this.regresar();
    });
  }

  eliminarRolSesionId(rolId, sesionId) {
    return this._rolSesion.eliminarRolSesionId(rolId, sesionId);
  }

  eliminarLinea({ rowData }) {
    this._util.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.eliminar,
        text: ``,
        action: this.DAT_BTNS.eliminar,
        funcion: this._rolSesion.eliminarRolSesionId(rowData.rolId, rowData.sesionId),
      }
    ).then((res: any) => {
      this.gridApi.updateRowData({ remove: this.gridApi.getSelectedRows() });
      console.log(res);
    });
  }
}
